import { Toast } from 'antd-mobile-v5'

export const showToast = (content = '', icon = 'success', position = 'center', callbackFn = () => {}) => {
  Toast.show({
    icon,
    content,
    position,
    afterClose: callbackFn,
  })
}
